import { initApi } from '@services/interceptor';

class ConfigService {
  constructor() {
    this.appConfig = {
      "api": {
        "baseUrl": "http://10.1.8.162",
        "mapUrl": "http://82.179.36.248:8081/api/v1/map/{z}/{x}/{y}.png",
        "debug": true,
        "timeout": 300000
      }
    };
    this.api = null
  }
  async loadAppConfig() {
    try {
      initApi(this)
      console.log('✅ Конфиг успешно загружен:', this.appConfig);
      return true;
    } catch (error) {
      console.error('❌ Ошибка загрузки конфига:', error);
      throw new Error(`Ошибка загрузки конфига. Конфиг не загружен: ${error}`);
    }
  }

  getConfig() {
    if (!this.appConfig) {
        throw new Error(`Ошибка получения конфига`);
    }
    return this.appConfig;
  }

  get(key) {
    const config = this.getConfig();
    const keys = key.split('.');
    let value = config;
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        throw new Error(`Ошибка получения параметра конфига`);
      }
    }
    return value;
  }

  async reloadConfig() {
    this.appConfig = null;
    return this.loadAppConfig();
  }
}

export const configService = new ConfigService();